import { render, staticRenderFns } from "./_NotificationSettings.vue?vue&type=template&id=0ab8baf0&"
import script from "./_NotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./_NotificationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports